module.exports = __webpack_public_path__ + "img/刘晓.a90332c6.jpg";